import { observer } from 'mobx-react-lite';
import { FC, useContext, useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Context } from '.';
import Header from './components/Header/Header';
import AppRoutes from "./services/RoutesServise";

const App: FC = () => {
  const { store } = useContext(Context);

  useEffect(() => {
    const initializeApp = async () => {
      if (localStorage.getItem("token")) {
        await store.checkAuth();
      } else {
        store.setLoading(false);
        store.setAuth(false);
      }
    };

    initializeApp();
  }, [store]);

  if (store.isLoading) {
    return <div></div>
  }

  return (
    <BrowserRouter>
      <div className='page lg:mx-32 mx-4'>
        <div className='page-messages'></div>
        <Header />
        <AppRoutes />
      </div>
    </BrowserRouter>
  );
}

export default observer(App);
